import { GoogleWorkspaceApiClient } from '@wix/google-workspace-api-interface/react-kit';
import { ModalsModule } from '../extensions/ModalsExtensions';
export const useGoogleCustomerCheck = () => {
  const {
    query: getGoogleCustomerDetailsQuery
  } = GoogleWorkspaceApiClient.fetchHooks.useGetGoogleCustomerDetails({});
  const googleCustomerExistsModal = ModalsModule.internals.domainsActionsModalsController.googleCustomerExists;
  const checkGoogleCustomerExists = async _ref => {
    let {
      domainName
    } = _ref;
    try {
      const {
        data: googleCustomerData
      } = await getGoogleCustomerDetailsQuery({
        domainName
      });
      if (googleCustomerData != null && googleCustomerData.found) {
        googleCustomerExistsModal.show({
          domainName
        });
        return true;
      }
    } catch {
      // If the check fails, don't block purchase
    }
    return false;
  };
  return {
    checkGoogleCustomerExists
  };
};
//# sourceMappingURL=useGoogleCustomerCheck.js.map